// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2083":"b7bbdfb1","3404":"9d33d379","5743":"6e094e4c"}[chunkId] + ".chunk.css";
};